import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-css'
import 'ace-builds/src-noconflict/theme-kuroir'

import ClosedBox from '../Survey/components/ClosedBox'
import surveyApi from '../../API/Survey'
import ImageUpload from './ImageUpload'
import ColorPicker from './ColorPicker'
import ImageSlider from './ImageSlider'
import Button from '../../UniformComponents/Button'
import Panel from '../../UniformComponents/Panel'
import InfoAccordion from '../InfoAccordion'
import Switch from '../../UniformComponents/Switch'

import '../../assets/css/preview.scss'

const getDefaultStyleSettings = () => ({
    background: {
        survey: '#FFFFFF',
        background: '#FFFFFF',
    },
    question: {
        text: '#3B4044',
        highlight: {
            colour: '#49BEF8',
            dark: '#0889c9',
            light: '#98dafb',
            superLight: '#d3effd',
        },
        outline: {
            colour: '#BCC5C9',
            light: '#d8dde0',
            instruction: '7b8d95',
            dark: '#7b8d95',
        },
    },
    navigation: {
        background: '#49BEF8',
        dark: '#0889c9',
        text: '#FFFFFF',
    },
    progress: {
        background: '#d8dde0',
        progress: {
            dark: '#82DDAC',
            light: '#52d08c',
        },
        showProgress: true,
        showPercent: true,
    },
    corners: 'rounded',
    bannerWidth: 100,
    bannerPCT: 100,
})

@observer
class Preview extends Component {
    infoAccordion = 'surveyStyling'

    constructor(props) {
        super(props)
        this.styleSettings = getDefaultStyleSettings()
        props.store.toggleInfoAccordion(this.infoAccordion, true)
        if (props.store.survey.metadata.displaySettings.styling) {
            try {
                this.constructStyling(this.styleSettings, JSON.parse(props.store.survey.metadata.displaySettings.styling))
                this.imageWidth = (this.styleSettings.bannerWidth / this.styleSettings.bannerPCT) * 100
            } catch (e) {
                console.log(`Error initiating styling from survey -> ${e}`)
            }
        }
        this.state = {
            updated: new Date().getTime(),
            corners: this.styleSettings.corners,
            tab: 'general',
        }
    }

    componentDidMount() {
        const { store } = this.props
        const { survey } = store
        console.log('componentDidMount')
        this.bannerUrl = survey.metadata.displaySettings.bannerUrl
        this.backgroundUrl = survey.metadata.displaySettings.backgroundUrl
    }

    constructStyling = (styling, client) => {
        try {
            Object.keys(styling).forEach((key) => {
                if (Object.hasOwnProperty.call(client, key)) {
                    if (typeof styling[key] === 'object') {
                        this.constructStyling(styling[key], client[key])
                    } else {
                        styling[key] = client[key]
                    }
                }
            })
        } catch (e) {
            console.log(`Error constructing styling -> ${e}`)
        }
    }

    DefaultColor = () => {
        const { store } = this.props
        const { survey } = store
        const { bannerPCT } = this.styleSettings
        this.styleSettings = getDefaultStyleSettings()
        this.styleSettings.bannerWidth = (this.imageWidth / 100) * bannerPCT
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
        this.messageIframe({
            styling: '',
            msgType: 'custom',
        })
        survey.metadata.displaySettings.customStyling = undefined
        this.setState({
            updated: new Date().getTime(),
            corners: this.styleSettings.corners,
        })
    }

    save = () => {
        const { store } = this.props
        const { survey } = store
        this.setImageWidth()
        survey.metadata.displaySettings.styling = JSON.stringify(this.styleSettings)
        surveyApi.updateSettings({
            displaySettings: survey.metadata.displaySettings.toJSON(),
        }, store)
    }

    getIframeUrl = () => {
        const { store } = this.props
        const { survey } = store

        return `${survey.getPreviewLink(true, store.useLatestUI)}&styling=1`
    }

    changeCustomCSS = (e, css) => {
        const { store } = this.props
        const { survey } = store
        const customCSS = css.getValue()
        console.log(`changeCustomCSS ${customCSS}`)
        this.messageIframe({
            styling: customCSS,
            msgType: 'custom',
        })
        survey.metadata.displaySettings.customStyling = customCSS
        surveyApi.updateSettings({
            displaySettings: survey.metadata.displaySettings.toJSON(),
        }, store)
    }

    setImageWidth = () => {
        this.styleSettings.bannerWidth = (this.imageWidth / 100) * this.styleSettings.bannerPCT
        console.log(`setImageWidth ${this.imageWidth} ${this.styleSettings.bannerPCT} ${this.styleSettings.bannerWidth}`)

        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    changeImageWidth = (value) => {
        console.log(`changeImageWidth ${value}`)
        this.styleSettings.bannerPCT = value
        this.setImageWidth()
    }

    selectUploadFile = () => {
        this.bannerInput.click()
    }

    selectBackgroundFile = () => {
        this.backgroundInput.click()
    }

    getBannerUrl = () => {
        const { store } = this.props
        const baseUrl = `${store.http.cdnUrl}/images/survey/`
        return baseUrl + this.bannerUrl
    }

    messageIframe = (msg) => {
        const { store } = this.props
        store.iframe.contentWindow.postMessage(JSON.stringify({ msg }), '*')
    }

    onUpload = ({ fileName, type, width }) => {
        const { store } = this.props
        const { survey } = store
        if (type === 'banner') {
            survey.metadata.displaySettings.bannerUrl = fileName
        } else {
            survey.metadata.displaySettings.backgroundUrl = fileName
        }

        if (type === 'banner') {
            this.imageWidth = width
            const displaySettings = survey.metadata.displaySettings.toJSON()
            const styling = survey.metadata.displaySettings.styling
                ? JSON.parse(survey.metadata.displaySettings.styling)
                : this.styleSettings
            this.styleSettings.bannerWidth = (this.imageWidth / 100) * styling.bannerPCT
            styling.bannerWidth = this.styleSettings.bannerWidth
            displaySettings.styling = JSON.stringify(styling)
            this.messageIframe({
                styling: this.styleSettings,
                msgType: 'style',
            })
            surveyApi.updateSettings({
                displaySettings,
            }, store)
        } else {
            surveyApi.updateSettings({
                displaySettings: survey.metadata.displaySettings.toJSON(),
            }, store)
        }
        this.messageIframe({
            fileName,
            type,
            msgType: 'imageUpload',
        })
    }

    surveyBackground = (colour) => {
        this.styleSettings.background.survey = colour.hex
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    htmlBackground = (colour) => {
        this.styleSettings.background.background = colour.hex
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    textColour = (colour) => {
        this.styleSettings.question.text = colour.hex
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    navBackground = (colour) => {
        this.styleSettings.navigation.background = colour.hex
        this.styleSettings.navigation.dark = this.calculateHsl(colour.hsl, -22)
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    navText = (colour) => {
        this.styleSettings.navigation.text = colour.hex
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    calculateHsl = (hsl, change) => `hsl(${hsl.h}, ${hsl.s * 100}%, ${hsl.l * 100 + (change)}%)`

    questionHighLight = (colour) => {
        this.styleSettings.question.highlight.colour = colour.hex
        this.styleSettings.question.highlight.dark = this.calculateHsl(colour.hsl, -22)
        this.styleSettings.question.highlight.light = this.calculateHsl(colour.hsl, 16)
        this.styleSettings.question.highlight.superLight = this.calculateHsl(colour.hsl, 28)
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    questionOutline = (colour) => {
        this.styleSettings.question.outline.colour = colour.hex
        this.styleSettings.question.outline.light = this.calculateHsl(colour.hsl, 10)
        this.styleSettings.question.outline.instruction = this.calculateHsl(colour.hsl, -27)
        this.styleSettings.question.outline.dark = this.calculateHsl(colour.hsl, -23)
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    progressBackground = (colour) => {
        this.styleSettings.progress.background = colour.hex
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    progressBar = (colour) => {
        this.styleSettings.progress.progress.light = colour.hex
        this.styleSettings.progress.progress.dark = this.calculateHsl(colour.hsl, -12)
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    showProgressBar = (checked) => {
        this.styleSettings.progress.showProgress = checked
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    showPercentage = (checked) => {
        this.styleSettings.progress.showPercent = checked
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
    }

    changeCorners = (e) => {
        console.log(`changeCorners ${e.target.value}`)
        const stateCopy = { ...this.state }
        stateCopy.corners = e.target.value
        this.styleSettings.corners = stateCopy.corners
        this.messageIframe({
            styling: this.styleSettings,
            msgType: 'style',
        })
        this.setState(stateCopy)
    }

    changeTab = (e) => {
        const tabName = e.target.getAttribute('tab')
        const stateCopy = { ...this.state }
        stateCopy.tab = tabName
        this.setState(stateCopy)
    }

    render() {
        const { store } = this.props
        const { survey } = store
        console.log(`rendered ${this.state.updated}`)
        return (
            <div>
                {survey.loading
                    && <div>{i18n.t('preview.loading')}</div>}

                {!survey.loading
                    && (
                        <div className="surveyPreview">
                            {survey.closed
                                && (
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ width: '70%', margin: 'auto' }}>
                                            <ClosedBox survey={survey} />
                                        </div>
                                    </div>
                                )}

                            <div style={{ display: 'flex', minHeight: 'calc(100vh - 235px)', gap: 20 }}>
                                {!survey.closed
                                    && (
                                        <Panel>
                                            <div className="heading">
                                                <h3>{i18n.t('preview.title')}</h3>
                                            </div>

                                            <br />

                                            <hr className="heading-divider" />

                                            <br />

                                            <InfoAccordion
                                                title={i18n.t('preview.infoTitle')}
                                                show={store.infoAccordion.get(this.infoAccordion)}
                                                toggle={() => store.toggleInfoAccordion(this.infoAccordion)}
                                            >
                                                <p dangerouslySetInnerHTML={{ __html: i18n.t('preview.infoContent') }}/>
                                            </InfoAccordion>

                                            <br />

                                            <h4>{i18n.t('preview.uploadLogo')}</h4>

                                            <br />

                                            <ImageUpload
                                                store={store}
                                                imageUrl={survey.metadata.displaySettings.bannerUrl}
                                                surveyId={survey.id}
                                                type="banner"
                                                onUpload={this.onUpload}
                                            />

                                            <br />

                                            <ImageSlider
                                                defaultValue={this.styleSettings.bannerPCT}
                                                onChange={this.changeImageWidth}
                                            />

                                            <br />

                                            <h4>{i18n.t('preview.pageBackground')}</h4>

                                            <br />

                                            <ImageUpload
                                                store={store}
                                                imageUrl={survey.metadata.displaySettings.backgroundUrl}
                                                surveyId={survey.id}
                                                type="bg"
                                                onUpload={this.onUpload}
                                            />

                                            <br />

                                            <h4>{i18n.t('preview.backgroundColors')}</h4>

                                            <br />

                                            <div className="section-container">
                                                <ColorPicker
                                                    label={i18n.t('preview.labelBackground')}
                                                    colour={this.styleSettings.background.background}
                                                    onChange={this.htmlBackground}
                                                    updated={this.state.updated}
                                                />

                                                <hr />

                                                <ColorPicker
                                                    label={i18n.t('preview.labelQuestions')}
                                                    colour={this.styleSettings.background.survey}
                                                    onChange={this.surveyBackground}
                                                    updated={this.state.updated}
                                                />
                                            </div>

                                            <br />

                                            <h4>{i18n.t('preview.questionColors')}</h4>

                                            <br />

                                            <div className="section-container">
                                                <ColorPicker
                                                    label={i18n.t('preview.labelText')}
                                                    colour={this.styleSettings.question.text}
                                                    onChange={this.textColour}
                                                    updated={this.state.updated}
                                                />

                                                <hr />

                                                <ColorPicker
                                                    label={i18n.t('preview.labelHighlight')}
                                                    colour={this.styleSettings.question.highlight.colour}
                                                    onChange={this.questionHighLight}
                                                    updated={this.state.updated}
                                                />

                                                <hr />

                                                <ColorPicker
                                                    label={i18n.t('preview.labelOutline')}
                                                    colour={this.styleSettings.question.outline.colour}
                                                    onChange={this.questionOutline}
                                                    updated={this.state.updated}
                                                />
                                            </div>

                                            <br />

                                            <h4>{i18n.t('preview.navigationButtons')}</h4>

                                            <br />

                                            <div className="section-container">
                                                <ColorPicker
                                                    label={i18n.t('preview.labelBackground')}
                                                    colour={this.styleSettings.navigation.background}
                                                    onChange={this.navBackground}
                                                    updated={this.state.updated}
                                                />

                                                <hr />

                                                <ColorPicker
                                                    label={i18n.t('preview.labelText')}
                                                    colour={this.styleSettings.navigation.text}
                                                    onChange={this.navText}
                                                    updated={this.state.updated}
                                                />
                                            </div>

                                            <br />

                                            <h4>{i18n.t('preview.progressBar')}</h4>

                                            <br />

                                            <div className="section-container">
                                                <div className="switch-container">
                                                    <label className="switch-row">
                                                        {i18n.t('preview.showProgress')}

                                                        <Switch
                                                            onToggle={this.showProgressBar}
                                                            icon="fas fa-check"
                                                            state={this.styleSettings.progress.showProgress}
                                                        />
                                                    </label>
                                                </div>

                                                <hr />

                                                <div className="switch-container">
                                                    <label className="switch-row">
                                                        {i18n.t('preview.showPercent')}

                                                        <Switch
                                                            onToggle={this.showPercentage}
                                                            icon="fas fa-check"
                                                            state={this.styleSettings.progress.showPercent}
                                                        />
                                                    </label>
                                                </div>
                                            </div>

                                            <br />

                                            <h4>{i18n.t('preview.customCSS')}</h4>

                                            <br />

                                            <AceEditor
                                                placeholder={i18n.t('preview.placeholder')}
                                                updated={this.state.updated}
                                                mode="css"
                                                theme="kuroir"
                                                name="customCss"
                                                style={{ width: '100%' }}
                                                className="customCss"
                                                onLoad={this.onLoad}
                                                onBlur={this.changeCustomCSS}
                                                fontSize={14}
                                                showPrintMargin={false}
                                                showGutter={false}
                                                highlightActiveLine={false}
                                                maxLines={100}
                                                value={
                                                    store.survey.metadata.displaySettings.customStyling
                                                        ? store.survey.metadata.displaySettings.customStyling
                                                            .replace(/(\}|\{)\s/gi, '$1\n')
                                                            .replace(/\s(\})/gi, '\n$1')
                                                        : ''
                                                }
                                            />

                                            <div className="action-container">
                                                <Button cssClass="regular primary" onClick={this.save}>{i18n.t('saveStyling')}</Button>

                                                <Button cssClass="regular tertiary" onClick={this.DefaultColor}>{i18n.t('default')}</Button>
                                            </div>
                                        </Panel>
                                    )}

                                <div
                                    style={{
                                        flex: 10,
                                    }}
                                    md={survey.closed ? 12 : 8}
                                >
                                    <iframe
                                        ref={(iframe) => { store.iframe = iframe }}
                                        frameBorder="0"
                                        width="100%"
                                        height="100%"
                                        src={this.getIframeUrl()}
                                        title="preview-window"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
            </div>
        )
    }
}

export default Preview
